import { AppShell, RequireRole, useSession } from "@saas/ui";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Link, Outlet, RouterProvider } from "react-router";
import { AdministratorsPage } from "./AdministratorsPage";
import { api } from "./api";
import { AuditLogPage } from "./AuditLogPage";
import { BackgroundJobsPage } from "./BackgroundJobsPage";
import { TenantDetailPage } from "./TenantDetailPage";
import { TenantsPage } from "./TenantsPage";
import { UsagePage } from "./UsagePage";

function Layout() {
  const session = useSession();
  useEffect(() => {
    // Records that the owner side is in use: from then on the bootstrap-administrator setting is ignored.
    void api.POST("/api/me/sign-ins");
  }, []);
  return (
    <AppShell
      surfaceLabel="Owner"
      nav={[
        { to: "/", label: "Tenants" },
        { to: "/usage", label: "Usage" },
        { to: "/administrators", label: "Administrators" },
        { to: "/background-jobs", label: "Background jobs" },
        { to: "/audit-log", label: "Audit log" },
      ]}
      userLabel={session.email ?? session.name ?? "Administrator"}
      logoutUrl={session.logoutUrl}
    >
      <Outlet />
    </AppShell>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { index: true, element: <TenantsPage /> },
        { path: "tenants/:id", element: <TenantDetailPage /> },
        { path: "usage", element: <UsagePage /> },
        { path: "administrators", element: <AdministratorsPage /> },
        { path: "background-jobs", element: <BackgroundJobsPage /> },
        { path: "audit-log", element: <AuditLogPage /> },
        { path: "*", element: <p>Page not found. <Link to="/">Back to tenants</Link></p> },
      ],
    },
  ],
  { basename: "/owner" },
);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element.");

createRoot(root).render(
  <StrictMode>
    <RequireRole surface="owner" title="Owner administration">
      <RouterProvider router={router} />
    </RequireRole>
  </StrictMode>,
);
